__turbopack_context__.v({
  "confirmBody": "_0ZZeta_confirmBody",
  "footer": "_0ZZeta_footer",
  "inlineFooter": "_0ZZeta_inlineFooter",
  "scrollRegion": "_0ZZeta_scrollRegion",
});
